module.exports = __webpack_public_path__ + "img/o.40ae5220.jpg";